// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInYears as fn } from "../differenceInYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInYearsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInYearsWithOptions;
